module.exports = __webpack_public_path__ + "assets/img/1a5b72026a344a8ac5001f26e5e534b1.png";